import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;